import {AfterContentInit, Component, ContentChildren, Input, OnInit, QueryList} from '@angular/core';
import {TabPanelComponent} from "./tab-panel/tab-panel.component";

@Component({
  selector: 'ui-tab',
  template: `<ul class="nav nav-tabs" id="myTab" role="tablist">
  <li class="nav-item" *ngFor="let item of tabs;index as i">
    <a class="nav-link "
       [attr.id]="'tab'+item.index"
       data-toggle="tab"
       (click)="toggle(item.index)"
       role="tab" aria-controls="home"
       [attr.aria-selected]="item.isOpen"
       [ngClass]="{'active':item.isOpen}">
      {{item.headerText}}
    </a>
  </li>
  <li role="presentation" class="dropdown" *ngIf="optionTabs.length" [ngClass]="{'show': isShowDropdown}">
    <a class="dropdown-toggle" id="myTabDrop" (click)="toggleDropdown()" data-toggle="dropdown" aria-controls="myTabDrop-contents" attr.aria-expanded="{{isShowDropdown}}">more
      <span class="caret"></span>
    </a>
    <ul class="dropdown-menu" aria-labelledby="myTabDrop" id="myTabDrop1-contents" [ngClass]="{'show': isShowDropdown}">
      <li *ngFor="let item of optionTabs">
        <a [attr.id]="'tab'+item.index"
           data-toggle="tab"
           (click)="toggle(item.index)"
           role="tab" aria-controls="home"
           [attr.aria-selected]="item.isOpen"
           [ngClass]="{'active':item.isOpen}">
          {{item.headerText}}</a>
      </li>
    </ul>
  </li>
</ul>
<div class="tab-content" id="myTabContent">
  <ng-content></ng-content>
</div>
`,
  styles: [``]
})
export class TabComponent implements OnInit, AfterContentInit {
  @Input() optionTabAfter: number = 3;
  public tabs: any[];
  public optionTabs: any[];
  @ContentChildren(TabPanelComponent) tabPanels: QueryList<TabPanelComponent>;

  isShowDropdown: boolean = false;

  constructor() {
  }

  ngOnInit() {

  }

  toggleDropdown() {
    this.isShowDropdown = !this.isShowDropdown;
  }

  toggle(i) {
    this.tabPanels.forEach(tab => {
      tab.isOpen = (tab.index === i)
    });
  }

  ngAfterContentInit() {
    this.tabs = [];
    this.optionTabs = []
    let count = 0;
    this.tabPanels.map(tab => {
      const tabItem = {
        headerText: tab.header,
        index: tab.index,
        isOpen: !!tab
      };
      count++;
      this.optionTabAfter = (this.optionTabAfter >= this.tabPanels.length) ? this.tabPanels.length : this.optionTabAfter;
      if (count <= this.optionTabAfter) {
        this.tabs.push(tabItem);
      } else {
        this.optionTabs.push(tabItem);
      }
    });
    console.log(this.tabs, this.optionTabs)
  }


}
